// Keep campaign shortcuts separate from broker review slugs (notably /xm).
export const comparisonCampaigns = [
  { path: '/vn', slug: 'vantage-markets', name: 'Vantage Markets' },
  { path: '/ic', slug: 'ic-markets', name: 'IC Markets' },
  { path: '/xm-compare', slug: 'xm', name: 'XM' },
  { path: '/rf', slug: 'roboforex', name: 'RoboForex' },
  { path: '/pu', slug: 'pu-prime', name: 'PU Prime' },
];

export const isComparisonCampaign = (pathname) =>
  comparisonCampaigns.some(({ path }) => path === pathname.replace(/\/$/, ''));